;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('CompanyItemController', CompanyItemController)

  /* @ngInject */
  function CompanyItemController ($scope, $state, $timeout, Utils, CONSTANTS, UserService, CompanyService) {
    const api = {
      _handleSuccessUpdateCompany
    }
    this.getApi = () => api

    $scope.getLogoUrl = function (customerCompanyId) {
      return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO_COLORED, [customerCompanyId])
    }

    $scope.changeUserCompany = function (customerCompanyId) {
      UserService.updateUserCompany(customerCompanyId).then(api._handleSuccessUpdateCompany)
    }

    function _handleSuccessUpdateCompany () {
      CompanyService.reloadWithNewCompany()
    }
  }
})()
